/* eslint-disable */
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

export interface DevToolsConfig {
  name: string
  enabled?: boolean
  logActions?: boolean
  logState?: boolean
  useReduxDevTools?: boolean
}

export class StoreDevTools {
  private devToolsExtension: any
  private config: Required<DevToolsConfig>

  constructor(config: DevToolsConfig) {
    this.config = {
      enabled: true,
      logActions: true,
      logState: true,
      useReduxDevTools: true,
      ...config,
    }

    if (this.config.enabled && this.config.useReduxDevTools) {
      this.connectReduxDevTools()
    }
  }

  private connectReduxDevTools() {
    if (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION__) {
      this.devToolsExtension = (window as any).__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: this.config.name,
        features: {
          pause: true,
          lock: true,
          persist: true,
          export: true,
          import: 'custom',
          jump: true,
          skip: true,
          reorder: true,
          dispatch: true,
        },
      })

      console.log(`✅ Redux DevTools connected for: ${this.config.name}`)
    } else {
      console.warn(
        `⚠️ Redux DevTools Extension not found. Install: https://chromewebstore.google.com/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd`,
      )
    }
  }

  // Loggear acciones
  logAction(actionName: string, payload?: any): void {
    if (!this.config.enabled) return

    if (this.config.logActions) {
      console.group(`🔵 [${this.config.name}] ${actionName}`)
      if (payload !== undefined) {
        console.log('Payload:', payload)
      }
      console.log('Time:', new Date().toLocaleTimeString())
      console.groupEnd()
    }
  }

  // Loggear estado
  logState(state: any): void {
    if (!this.config.enabled || !this.config.logState) return
    console.log(`📦 [${this.config.name}] State`)
  }

  // Enviar a Redux DevTools
  sendToDevTools(actionName: string, state: any, payload?: any): void {
    if (!this.config.enabled || !this.devToolsExtension) return

    this.devToolsExtension.send(
      {
        type: `[${this.config.name}] ${actionName}`,
        payload,
      },
      state,
    )
  }

  // Inicializar estado en DevTools
  initState(state: any): void {
    if (this.devToolsExtension) {
      this.devToolsExtension.init(state)
    }
  }

  tapLog<T>(label: string) {
    return tap<T>({
      next: (value) => {
        if (this.config.enabled) {
          console.log(`⚡ [${this.config.name}] ${label}:`, value)
        }
      },
      error: (error) => {
        if (this.config.enabled) {
          console.error(`❌ [${this.config.name}] ${label} Error:`, error)
        }
      },
      complete: () => {
        if (this.config.enabled) {
          console.log(`✔️ [${this.config.name}] ${label} Complete`)
        }
      },
    })
  }

  monitorState<T>(state$: Observable<T>): Observable<T> {
    if (!this.config.enabled) return state$

    return state$.pipe(
      tap((state) => {
        this.logState(state)
        if (this.devToolsExtension) {
          this.devToolsExtension.send('STATE_UPDATE', state)
        }
      }),
    )
  }
}

export function createStoreDevTools(name: string, enabled = true): StoreDevTools {
  return new StoreDevTools({
    name,
    enabled: enabled && typeof window !== 'undefined',
  })
}
